import React, { useEffect, useMemo, useState, useRef } from 'react'
import Marquee from 'react-fast-marquee';
import { motion } from 'framer-motion';
import { animate } from 'animejs';
import screenshot from '../assets/screenshot.png';
import screenshort1 from '../assets/screenshort1.png';
import screenshort2 from '../assets/screenshort2.png';
import screenshort3 from '../assets/screenshort3.png';
import screenshort5 from '../assets/screenshort5.png';
import screenshort6 from '../assets/screenshort6.png';
import screenshort7 from '../assets/screenshort7.png';
import screenshort8 from '../assets/screenshort8.png';
import apiService from '../apiservice/apiService';
import Carousel from "react-bootstrap/Carousel";

function HomeMain() {
  const [mainImage, setMainImage] = useState(screenshot);
  const [isClient, setIsClient] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);
   const textRef = useRef(null);
  const hasRun = useRef(false);

useEffect(() => {
  if (!isClient || hasRun.current) return;

  const timer = setTimeout(() => {
    if (!textRef.current || hasRun.current) return;

    const wrapper = textRef.current;

    hasRun.current = true;

    // Get original HTML (keeps span)
    const originalHTML = wrapper.innerHTML;

    // Create temp element
    const temp = document.createElement("div");
    temp.innerHTML = originalHTML;

    wrapper.innerHTML = "";

    // Walk through nodes
    const walk = (node) => {
      if (node.nodeType === 3) {
        // Text node
        const chars = node.textContent.split("");

        chars.forEach((char) => {
          if (char === " ") {
            const span = document.createElement("span");
            span.className = "space";
            span.innerHTML = "&nbsp;";
            wrapper.appendChild(span);
          } else {
            const span = document.createElement("span");
            span.className = "letter";
            span.textContent = char;
            wrapper.appendChild(span);
          }
        });
      }

      if (node.nodeType === 1) {
        // Element node (like span.happening)
        const className = node.className || "";

        node.childNodes.forEach((child) => {
          if (child.nodeType === 3) {
            child.textContent.split("").forEach((char) => {
              if (char === " ") {
                const span = document.createElement("span");
                span.className = "space";
                span.innerHTML = "&nbsp;";
                wrapper.appendChild(span);
              } else {
                const span = document.createElement("span");
                span.className = `letter ${className}`;
                span.textContent = char;
                wrapper.appendChild(span);
              }
            });
          }
        });
      }
    };

    temp.childNodes.forEach(walk);

    // Animate
    const letters = wrapper.querySelectorAll(".letter");

    letters.forEach((letter, i) => {
      letter.style.filter = "blur(3px)";

      animate(letter, {
        opacity: [0, 1],
        duration: 500,
        delay: i * 50,
        easing: "easeInOutQuad",

        complete() {
          letter.style.filter = "blur(0px)";
        },
      });
    });
  }, 100);

  return () => clearTimeout(timer);
}, [isClient]);


 useEffect(() => {
  if (!isClient || hasRun.current) return;

  const timer = setTimeout(() => {
    if (!textRef.current || hasRun.current) return;

    const textWrapper = textRef.current;
    const text = textWrapper.textContent;

    if (!text) return;

    hasRun.current = true;

    // Split text into characters
    const chars = text.split("");

    // Wrap each character (including space)
    textWrapper.innerHTML = chars
      .map((char) =>
        char === " "
          ? `<span class="space">&nbsp;</span>`
          : `<span class="letter">${char}</span>`
      )
      .join("");

    // Select only letters (not spaces)
    const letterSpans = textWrapper.querySelectorAll(".letter");

    // Animate letters
    letterSpans.forEach((letter, i) => {
      letter.style.filter = "blur(3px)";
      letter.style.transition = "filter 0.3s ease";

      animate(letter, {
        opacity: [0, 1],
        easing: "easeInOutQuad",
        duration: 500,
        delay: 50 * (i + 1),

        begin() {
          letter.style.filter = "blur(3px)";
        },

        update(anim) {
          const progress = anim.progress / 100;
          let blurValue;

          if (progress <= 0.85) {
            blurValue = 3 * (1 - progress);
          } else {
            const endProgress = (progress - 0.85) / 0.15;
            blurValue = 3 * 0.15 + 1.5 * endProgress;
          }

          letter.style.filter = `blur(${blurValue}px)`;
        },

        complete() {
          setTimeout(() => {
            letter.style.filter = "blur(0px)";
          }, 100);
        },
      });
    });
  }, 100);

  return () => clearTimeout(timer);
}, [isClient]);


const autoPlay = true; 
const loop = true;     
const slideTime = 4000;
  const images = useMemo(
    () => [
      screenshot,
      screenshort1,
      screenshort2,
      screenshort3,
      screenshort5,
      screenshort6,
      screenshort7,
      screenshort8,
    ],
    []
  );
  const [submitloader, setSubmitloader] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [greenMessage, setGreenMessage] = useState('');
  const [formData, setFormData] = useState({
    full_name: '',
    phone_number: '',
    work_email: '',
    company_name: '',
    country: '',
    users: '',
    referral: '',
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const newErrors = {};

    // Check for empty fields
    Object.keys(formData).forEach((key) => {
      if (!formData[key]) {
        newErrors[key] = `${key.replace('_', ' ')} is required`;
      }
    });
    return Object.keys(newErrors).length === 0;
  };

  useEffect(() => {
    setIsClient(true);
  }, []);

  useEffect(() => {
    if (!isClient) return;

    const tabs = document.querySelectorAll('.tab_box_1');

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        const isActive = tab.classList.contains('active');
        tab.classList.toggle('active');

        if (!isActive) {
          // Update React state instead of direct DOM manipulation
          setMainImage(images[index]);
        }
      });
    });

    // Default activate first tab
    if (tabs.length > 0) {
      tabs[0].classList.add('active');
      setMainImage(images[0]);
    }

    // Cleanup event listeners
    return () => {
      tabs.forEach((tab) => {
        const clone = tab.cloneNode(true);
        tab.replaceWith(clone);
      });
    };
  }, [images, isClient]);

  if (!isClient) return null;
  const handleSubmit = async (e) => {
    e.preventDefault();
    setGreenMessage('');
    if (!validateForm()) {
      setErrorMessage('Please fill all the fields before proceeding.');
      return;
    }

    setSubmitloader(true);

    try {
      const jsonParams = {
        full_name: formData.full_name,
        phone_number: formData.phone_number,
        work_email: formData.work_email,
        company_name: formData.company_name,
        country: formData.country,
        users: formData.users,
        referral: formData.referral,
      };

      // Convert object to query string
      const queryString = new URLSearchParams(jsonParams).toString();

      // Send GET request with query string
      const response = await apiService.post(`contact-us?${queryString}`);
      if (response && response.data && response.data.success === true) {
        setGreenMessage(response.data.message || "Details submitted successfully!");
        setErrorMessage('');
        setFormData({
          full_name: '',
          phone_number: '',
          work_email: '',
          company_name: '',
          country: '',
          users: '',
          referral: '',
        });
      } else {
        setErrorMessage(response.data.message || "Failed. Please try again!");
      }
    } catch (error) {
      console.error("Submission error:", error);
    } finally {
      setSubmitloader(false);
    }
  };
  const industries = [
    {
      title: "IT & Software Development",
      desc: "Monitor remote teams, track progress, and optimize productivity.",
      icon: require("../assets/Industry-Types/it-software.png"),
    },
    {
      title: "BPO & Customer Support",
      desc: "Manage shifts, track idle time, and improve service quality.",
      icon: require("../assets/Industry-Types/bpo.png"),
    },
    {
      title: "Marketing Agencies",
      desc: "Stay on top of project timelines and creative collaboration.",
      icon: require("../assets/Industry-Types/marketing&edu.png"),
    },
    {
      title: "E-commerce & Retail",
      desc: "Ensure team accountability and manage operational efficiency.",
      icon: require("../assets/Industry-Types/ecommerce.png"),
    },
    {
      title: "Consulting Firms",
      desc: "Measure billable hours and team utilization effectively.",
      icon: require("../assets/Industry-Types/consulting.png"),
    },
    {
      title: "Education & Training",
      desc: "Monitor teaching sessions, attendance, and engagement levels.",
      icon: require("../assets/Industry-Types/marketing&edu.png"),
    },
    {
      title: "Finance & Accounting",
      desc: "Track time spent on sensitive tasks and maintain compliance.",
      icon: require("../assets/Industry-Types/finance.png"),
    },
    {
      title: "Freelance Teams & Startups",
      desc: "Collaborate in real-time and keep deliverables on track.",
      icon: require("../assets/Industry-Types/freelance.png"),
    },
  ];

  const testimonials = [
    {
      name: "Founder",
      company: "Sky appz",
      icon: require("../assets/colorlogo/skyappzcolor.png"),
      message:
        "LOOV has transformed how we manage our remote development team. The automatic screenshot feature gives us complete transparency without being intrusive. We've seen a 40% increase in productivity since implementing it. The real-time tracking helps us identify bottlenecks early and keep projects on track."
    },
    {
      name: "HR Executive",
      company: "MS IT Park pvt ltd",
      icon: require("../assets/colorlogo/msitparkcolor.png"),
      message:
        "As a tech park managing multiple startups, we needed a solution that could scale with our diverse client base. LOOV's flexible features and easy setup made it perfect for our needs. The attendance tracking and break reports have been game-changers for our HR team. Highly recommended for any business managing remote teams."
    },
    {
      name: "Founder",
      company: "Clear Touch",
      icon: require("../assets/colorlogo/cleartouchcolor.png"), 
      message:
        "The live screenshot feature is exactly what we needed for our customer support team. Being able to see what our agents are working on in real-time has improved our training process significantly. The app and URL tracking feature helps us ensure compliance and optimize workflows. Excellent tool for maintaining quality standards."
    },
    {
      name: "Operations Head",
      company: "Lighthouse",
      icon: require("../assets/colorlogo/lighthousecolor.png"),
      message:
        "We've tried multiple productivity tracking tools, but LOOV stands out with its comprehensive features and user-friendly interface. The productivity tracking metrics give us accurate insights into actual work hours versus idle time. Our team appreciates the transparency, and management loves the detailed reports. It's been a win-win for everyone."
    },
    {
      name: "The Manager",
      company: "Chat Pro",
      icon: require("../assets/colorlogo/chatprocolor.png"),
      message:
        "Running an AI consulting firm requires precise time tracking for client billing. LOOV's productivity tracking and detailed reports have streamlined our invoicing process. The idle time alerts help us maintain high standards, and the break reports ensure our team maintains a healthy work-life balance. The ROI has been exceptional."
    },
    {
      name: "HR Executive",
      company: "Prebuy",
      icon: require("../assets/colorlogo/prebuycolor.png"),
      message:
        "The automatic attendance tracking has eliminated all the manual work our HR department was doing. Combined with the live cam shots, we can confidently verify remote employee presence. The dashboard is intuitive, and the reports are comprehensive. LOOV has become an essential part of our daily operations."
    },
    {
      name: "The Project Manager",
      company: "DIODS",
      icon: require("../assets/colorlogo/diodscolor.png"),
      message:
        "What impressed us most was how non-intrusive LOOV is while still providing all the insights we need. Our team adapted quickly, and the productivity improvements were noticeable within the first month. The app tracking feature helps us optimize software usage, and the custom idle thresholds are perfect for our workflow. Outstanding product!"
    }
  ];


 const features = [
    {
      tag: "Screenshots",
      icon: require("../assets/features/screenshot 1.png"),
      image: require("../assets/screensht.png"),
      title: "Capture your team's work at regular intervals.",
      desc: "Take automatic screenshots every 5 or 10 minutes to monitor tasks, ensure focus, and maintain transparency — all without interrupting the flow. "
    },
    {
      tag: "Live Screenshot",
      icon: require("../assets/features/play-button 1.png"),
      image: require("../assets/Live_Reports.png"),
      title: "See what your team is doing right now.",
      desc: "No need to guess — watch screens live to understand your team's activity at any givenmoment. Whether you're troubleshooting, training, or supervising — it’s all instant."
    },
    {
      tag: "Live Cam Shot",
      icon: require("../assets/features/camera 1.png"),
      image: require("../assets/live-cam.png"),
      title: "See who's actually at the desk.",
      desc: "Get periodic webcam snapshots to visually confirm employee presence and workspace setup — without intrusive live video or continuous surveillance."
    },
    {
      tag: "Productivity Tracking",
      icon: require("../assets/features/cms.png"),
      image: require("../assets/production.png"),
      title: "See the true output behind the logged hours.",
      desc: "Just being online doesn’t mean being productive. Our system smartly identifies keyboardand mouse activity to calculate actual productive hours vs idle time."
    },
    {
      tag: "Attendance & Work Hours",
      icon: require("../assets/features/event.png"),
      image: require("../assets/attendance&break.png"),
      title: "Automatic login/logout tracking, simplified.",
      desc: "No more manual attendance or punching cards. Your team’s presence is auto-logged assoon as they start their system."
    },
    {
      tag: "Break & Overtime Reports",
      icon: require("../assets/features/event.png"),
      image: require("../assets/livereport.png"),
      title: "Support a balanced work-life culture.",
      desc: "Track short breaks, lunch hours, and after-hours work accurately. Ensure no one isoverworked — or underperforming — and that wellness and efficiency go hand-in-hand."
    },
    {
      tag: "App & URL Tracking",
      icon: require("../assets/features/mouse-clicker.png"),
      image: require("../assets/app&url.png"),
      title: "Know how time is being spent. Everywhere.",
      desc: "Track every website and application accessed during work hours. Easily identify unproductive patterns, time leaks, or distractions, and help your team stay focused."
    },
    {
      tag: "Idle Time Alerts",
      icon: require("../assets/features/man.png"),
      image: require("../assets/productivity-drop.png"),
      title: "Get notified when productivity drops.",
      desc: "Set custom idle thresholds — if a user doesn’t move the mouse or keyboard for a set duration, a notification is sent both to them and your dashboard."
    }
  ];


const handleSelect = (selectedIndex) => {
    setActiveSlide(selectedIndex);
  };



  return (
    <div className="container-fluid backdropsets_blur">
      <div className="row justify-content-center">
        <div className="col-12 hero_section py-5">
          <div className='text-center'>
            <span className='rocket'>
              <img src={require("../assets/rocket.svg").default} alt="Hero" />

              Start Free — No Credit Card Required</span></div>
          <div className="row justify-content-center  mt-5">
           <div className="text_link position-relative anton">

<h1 ref={textRef} className="ml3 hero-title">
  <span className="know-text">Know What's</span>{" "}
  <span className="happening">Happening.</span>
</h1>




  <br />

  <div className="d-flex w-100 justify-content-center">
    <img className='badge-pos floating'
      src={require("../assets/tradingGroup .svg").default}
      alt="Hero"
    />
  </div>

  <span>Every Minute.</span>

</div>

            <p className="mb-0">
              Live screenshots, activity tracking, and productivity insights in one simple dashboard.
            </p>

            <div className="d-flex justify-content-center mt-4">
              <a target='_blank' rel="noopener noreferrer" href="https://view.loov.in/sign-up" className="text-decoration-none">
                <button className="new_btn">
                  <span className="btn_text">Start Free Trial</span>
                  <div className="right_chrown_btn">
                    <img className="chrown_btn" src={require("../assets/chrown-right.svg").default} alt="arrow" />
                  </div>
                </button>
              </a>
            </div>



          </div>
        </div>

        <div className="col-12 position-relative mt-2 " >
          <div className="container px-md-auto px-0">
            <div className="d-flex align-items-center justify-content-center">
              <div className="text-center d-lg-block d-md-none d-none">
                <motion.img 
                  id="main-image-desktop" 
                  src={mainImage} 
                  alt="" 
                  key={mainImage}
                  initial={{ opacity: 0, scale: 0.95 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ 
                    duration: 0.4, 
                    ease: [0.25, 0.46, 0.45, 0.94] 
                  }}
                />
              </div>
              <div className="entire_box">
                <div className="box_2">
                  <h1 className="text-primary text-center fw-bold fs-2">Set up your Workspace</h1>
                  <p className="text-center text-black fw-normal fs-14">
                    Start with what you need, customize as you go.
                  </p>
                  <div className="text-center d-lg-none d-md-block mb-3">
                    <motion.img 
                      id="main-image-mobile" 
                      className='w-100' 
                      src={mainImage} 
                      alt="" 
                      key={mainImage}
                      initial={{ opacity: 0, scale: 0.95 }}
                      animate={{ opacity: 1, scale: 1 }}
                      transition={{ 
                        duration: 0.4, 
                        ease: [0.25, 0.46, 0.45, 0.94] 
                      }}
                    />
                  </div>
                  <div className="row g-2 justify-content-center">
                    <div className="col-6">
                      <div className="tab_box_1 col-12 mx-auto">
                        <div className="text-center">
                          <img src={require("../assets/screenshot.svg").default} alt="" />
                          <h5 className="text-gray fw-semibold fs-6">Screenshots</h5>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="tab_box_1 col-12 mx-auto">
                        <div className="text-center">
                          <img src={require("../assets/camshort.svg").default} alt="" />
                          <h5 className="text-gray fw-semibold fs-6">Camshots</h5>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="tab_box_1 col-12 mx-auto">
                        <div className="text-center">
                          <img src={require("../assets/screenshot.svg").default} alt="" />
                          <h5 className="text-gray fw-semibold fs-6">Live Screenshot</h5>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="tab_box_1 col-12 mx-auto">
                        <div className="text-center">
                          <img src={require("../assets/mouse-clicker.svg").default} alt="" />
                          <h5 className="text-gray fw-semibold fs-6">App & URL Tracking</h5>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="tab_box_1 col-12 mx-auto">
                        <div className="text-center">
                          <img src={require("../assets/calender.svg").default} alt="" />
                          <h5 className="text-gray fw-semibold fs-6">Attendance</h5>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="tab_box_1 col-12 mx-auto">
                        <div className="text-center">
                          <img src={require("../assets/coffee-break.svg").default} alt="" />
                          <h5 className="text-gray fw-semibold fs-6">Break Reports</h5>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="tab_box_1 col-12 mx-auto">
                        <div className="text-center">
                          <img src={require("../assets/idealman.svg").default} alt="" />
                          <h5 className="text-gray fw-semibold fs-6">Idle Time Warnings</h5>
                        </div>
                      </div>
                    </div>
                    <div className="col-6">
                      <div className="tab_box_1 col-12 mx-auto">
                        <div className="text-center">
                          <img src={require("../assets/star.svg").default} alt="" />
                          <h5 className="text-gray fw-semibold fs-6">Highlights</h5>
                        </div>
                      </div>
                    </div>
                    {/* <Link to='https://view.loov.in/sign-up' target="_blank" className="col-md-8 mt-4">
                      <button className="text-white Schedule_btn">Start Free Trial</button>
                    </Link> */}
                     <a href='https://view.loov.in/sign-up' class="allhovebtn allhovebtn--svg js-animated-button text-white">
                                        <span class="allhovebtn--svg__label">Start Free Trial</span>
                                        <svg width="190" x="0px" y="0px" viewBox="0 0 60 60" class="allhovebtn--svg__circle">
                                          <circle fill="#9FCBFF" cx="30" cy="30" r="28.7" class="js-discover-circle"></circle>
                                        </svg>
                                        <svg x="0px" y="0px" preserveAspectRatio="none" viewBox="2 29.3 56.9 13.4" width="190" class="allhovebtn--svg__border">
                                          <g class="allhovebtn--svg__border--left js-discover-left-border">
                                            <path fill="none" stroke="#0092D3" stroke-width="0.5" stroke-miterlimit="1" d="M30.4,41.9H9c0,0-6.2-0.3-6.2-5.9S9,30.1,9,30.1h21.4"></path>
                                          </g>
                                          <g class="allhovebtn--svg__border--right js-discover-right-border">
                                            <path fill="none" stroke="#0092D3" stroke-width="0.5" stroke-miterlimit="1" d="M30.4,41.9h21.5c0,0,6.1-0.4,6.1-5.9s-6-5.9-6-5.9H30.4"></path>
                                          </g>
                                        </svg>
                                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='col-md-12 p-0 mt-5'>
          <div className='text-dark text-center  py-2'>
            <p className="mb-0 fs-22">
            Trusted by the most innovative companies in the world            </p>
          </div>
        </div>
        <div className="col-12 ">
          <div className="my-3">
            <Marquee speed={50} autoFill={true} gradient={false}>
              <img className='mx-4' src={require("../assets/marque-logo/skyappz-marque.png")} alt="" />
              <img className='mx-4' src={require("../assets/marque-logo/msitpark-marque.png")} alt="" />
              <img className='mx-4' src={require("../assets/marque-logo/cleartouch-marque.png")} alt="" />
              <img className='mx-4' src={require("../assets/marque-logo/lighthouse-marque.png")} alt="" />
              <img className='mx-4' src={require("../assets/marque-logo/chatpro-marque.png")} alt="" />
              <img className='mx-4' src={require("../assets/marque-logo/prebuy-marque.png")} alt="" />
               <img className='mx-4' src={require("../assets/marque-logo/diods-marque.png")} alt="" />
            </Marquee>
          </div>
        </div>

        <div className='col-md-12'>
          <div className=''>
            <div className="row justify-content-center Productivity-features">
              <h2 className="text-center Features  mt-md-5 fw-bold col-md-10 anton">
                Features That Help<span className="text-Companies-features ms-2">Companies Increase <br></br>
                  Productivity & Operate More Efficiently</span>
              </h2>
            </div>

             <div className="screenshots-section py-5">
      <div className="container">

      
        <div className="row justify-content-center g-4">
          {features.map((item, index) => (
            <div
              key={index}
              className="col-12 col-md-6 d-flex"
            >
              <div className="feature-box d-flex flex-column w-100">
                <div className="d-flex justify-content-center py-3">
                  <div className="tag d-flex align-items-center px-3 py-2">
                    <img
                      src={item.icon}
                      alt={item.tag}
                      className="img-fluid"
                      style={{ width: "22px" }}
                    />
                    <span className="ms-2">{item.tag}</span>
                  </div>
                </div>

                <div className="feature-card h-100 d-flex flex-column">
                  <div className="image-wrapper mb-3">
                    <img
                      src={item.image}
                      alt={item.tag}
                      className="img-fluid feature-img"
                    />
                  </div>

                  <h4 className="my-2">{item.title}</h4>

                  <p className="text-muted flex-grow-1 p-2">
                    {item.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
          </div>
        </div>

        <section className="py-5">
          <div className="contaer">
            <h1 className="text-center fw-bold mb-5 anton Feature">
              Works Better for <span className="text-Companies">these Industries</span>
            </h1>


            <div className="row g-4 justify-content-center">
              {industries.map((item, index) => (
                <div
                  key={index}
                  className="col-12 col-sm-6 col-lg-4  py-2"
                >
                  <div className="card h-100 backdropsets_blur shadow-sm border-md text-center p-5 rounded-4 industry-hover">
                    <div className="mb-3">
                      <span className='img-border'>
                       <img
                      src={item.icon}
                      alt={item.tag}
                      className="img-fluid"
                      style={{ width: "30px" }}
                    /></span>
                    </div>


                    <h5 className="fw-semibold mb-2">
                      {item.title}
                    </h5>


                    <p className="text-muted mb-0">
                      {item.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>


        <div className="col-12 mt-md-5 mt-4 py-5">
      <div className="container">

        {/* Heading */}
        <div className="text-center mb-5">
          <h1 className="fw-bold anton Feature">
            See what <span className='text-Companies'> our customers say</span>
          </h1>
        </div>

        <Carousel
      activeIndex={activeSlide}
      onSelect={handleSelect}
      indicators={false}
      controls={false}
      interval={autoPlay ? slideTime : null}
      pause={autoPlay ? "hover" : false}
      wrap={loop}
      className="testimonial-carousel"
    >
          {testimonials.map((item, index) => (
            <Carousel.Item key={index}>

              <div className="row justify-content-center">

                <div className="col-md-10 col-12">
                  <div className="testimonial-card industry-hover p-4 shadow rounded">

                    <div className="row align-items-center">

                      <div className="col-md-4 col-12 text-center mb-3 mb-md-0">
                        <img
                          src={item.icon}
                          alt="user"
                          className="img-fluid testimonial-img"
                        />
                      </div>

                      <div className="col-md-8 col-12 text-center text-md-start">

                        <h5 className="fw-bold mb-1">
                          {item.name}
                        </h5>

                        <small className="fw-bold mb-1">
                          {item.company}
                        </small>

                        <p className="mt-3 text-muted">
                          {item.message}
                        </p>

                      </div>

                    </div>

                  </div>
                </div>

              </div>

            </Carousel.Item>
          ))}
        </Carousel>

        {/* Custom Buttons */}
        <div className="d-flex justify-content-center gap-3 mt-4">

          <button
            className="btn bg-gray"
            onClick={() =>
              setActiveSlide(
                activeSlide === 0
                  ? testimonials.length - 1
                  : activeSlide - 1
              )
            }
          >
            ←
          </button>

          <button
            className="btn bg-gray"
            onClick={() =>
              setActiveSlide(
                activeSlide === testimonials.length - 1
                  ? 0
                  : activeSlide + 1
              )
            }
          >
            →
          </button>

        </div>

      </div>
    </div>
        <div className="py-5 faq-section">

          <div className="container">

            <div className="text-center mb-5">
              <h1 className="fw-bold anton">Common <span className='text-Companies'> Question</span></h1>
            </div>

            <div className="row justify-content-center">

              <div className="col-md-10 col-12 testimonial-card rounded-0">

                <div className="accordion" id="faqAccordion">

                  <div className="accordion-item border-0 border-bottom">

                    <h2 className="accordion-header">

                      <button
                        className="accordion-button fw-bold"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq1"
                      >
                        Is It Auto-Renewal?
                      </button>

                    </h2>

                    <div
                      id="faq1"
                      className="accordion-collapse collapse show"
                      data-bs-parent="#faqAccordion"
                    >
                      <div className="accordion-body text-muted">

                        No, your plan will not auto-renew. It’s a prepaid monthly subscription. An invoice will be generated and shared, and payment must be made manually to continue using the service.

                      </div>
                    </div>

                  </div>

                  <div className="accordion-item border-0 border-bottom">

                    <h2 className="accordion-header">

                      <button
                        className="accordion-button fw-semibold collapsed "
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq2"
                      >
                        Is A Credit Card Required For The Free Trial?
                      </button>

                    </h2>

                    <div
                      id="faq2"
                      className="accordion-collapse collapse"
                      data-bs-parent="#faqAccordion"
                    >
                      <div className="accordion-body text-muted">

                        No, you can start the free trial without
                        providing credit card details.

                      </div>
                    </div>

                  </div>

                  <div className="accordion-item border-0 border-bottom">

                    <h2 className="accordion-header">

                      <button
                        className="accordion-button fw-semibold collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq3"
                      >
                        Can I Request Custom Features Or Integrations?
                      </button>

                    </h2>

                    <div
                      id="faq3"
                      className="accordion-collapse collapse"
                      data-bs-parent="#faqAccordion"
                    >
                      <div className="accordion-body text-muted">

                        Yes, you can contact our support team
                        for custom feature requests.

                      </div>
                    </div>

                  </div>

                  <div className="accordion-item border-0 border-bottom">

                    <h2 className="accordion-header">

                      <button
                        className="accordion-button fw-semibold collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq4"
                      >
                        Can I Upgrade Or Downgrade My Plan Later?
                      </button>

                    </h2>

                    <div
                      id="faq4"
                      className="accordion-collapse collapse"
                      data-bs-parent="#faqAccordion"
                    >
                      <div className="accordion-body text-muted">

                        Yes, you can change your plan anytime
                        from your account dashboard.

                      </div>
                    </div>

                  </div>

                  {/* Item 5 */}
                  <div className="accordion-item border-0 border-bottom">

                    <h2 className="accordion-header">

                      <button
                        className="accordion-button fw-semibold collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq5"
                      >
                        What Happens If I Miss A Payment?
                      </button>

                    </h2>

                    <div
                      id="faq5"
                      className="accordion-collapse collapse"
                      data-bs-parent="#faqAccordion"
                    >
                      <div className="accordion-body text-muted">

                        Your service may be temporarily suspended
                        until payment is completed.

                      </div>
                    </div>

                  </div>

                  {/* Item 6 */}
                  <div className="accordion-item border-0 border-bottom">

                    <h2 className="accordion-header">

                      <button
                        className="accordion-button fw-semibold collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#faq6"
                      >
                        Is There A Minimum Commitment?
                      </button>

                    </h2>

                    <div
                      id="faq6"
                      className="accordion-collapse collapse"
                      data-bs-parent="#faqAccordion"
                    >
                      <div className="accordion-body text-muted">

                        No, there is no minimum commitment.
                        You can cancel anytime.

                      </div>
                    </div>

                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>


        <div className="col-12 mt-md-5 mt-4 px-0">
          <div className="contact_back py-md-5 py-3">
            <div className="row justify-content-center align-items-center">
              <div className="col-md-10 col-lg-11">
                <div className="row justify-content-center align-items-center">
                  <div className="col-lg-6 col-md-12 col-12">
                    <div>
                      <h1 className="fw-bold mt-2 anton">Schedule Your Free Demo</h1>
                      <div style={{ backgroundColor: '#000', height: '7px', width: '102px' }}></div>
                      <p className="mb-4 text-black mt-2 pe-md-5">
Take a quick demo and see how companies increased productivity and transformed team performance with LOOV.                      </p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="contact_white col-lg-11">
                      <form className="row" onSubmit={handleSubmit}>
                        <div className="col-md-12">
                          <input type="text" className="form-control ipt_sty" placeholder="Full Name" name="full_name" value={formData.full_name} onChange={handleInputChange} />
                        </div>
                        <div className="col-md-6">
                          <input type="text" className="form-control ipt_sty mt-3" placeholder="Phone Number" name="phone_number" value={formData.phone_number} onChange={handleInputChange} onInput={(e) => e.target.value = e.target.value.replace(/[^0-9]/g, '')} />
                        </div>
                        <div className="col-md-6">
                          <input type="email" className="form-control ipt_sty mt-3" placeholder="Work Email" name="work_email" value={formData.work_email} onChange={handleInputChange} />
                        </div>
                        <div className="col-md-12">
                          <input type="text" className="form-control ipt_sty mt-3" placeholder="Company Name" name="company_name" value={formData.company_name} onChange={handleInputChange} />
                        </div>
                        <div className="col-md-12">
                          <input type="text" className="form-control ipt_sty mt-3" placeholder="Country" name="country" value={formData.country} onChange={handleInputChange} />
                        </div>
                        <div className="col-md-12">
                          <div className="form-group mt-3">
                            <select className="form-select ipt_sty" name="users" value={formData.users} onChange={handleInputChange}>
                              <option value="">No of Handy user/ Subscription required</option>
                              <option value="1">1 User</option>
                              <option value="5">5 Users</option>
                              <option value="10">10 Users</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="form-group mt-3 mb-3">
                            <select className="form-select ipt_sty" name="referral" value={formData.referral} onChange={handleInputChange}>
                              <option value="">How did you hear about us?</option>
                              <option value="google">Google</option>
                              <option value="social">Social Media</option>
                              <option value="friend">Friend</option>
                              <option value="other">Other</option>
                            </select>
                          </div>
                        </div>
                        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                        {greenMessage && <p style={{ color: 'green' }}>{greenMessage}</p>}
                        <div className="col-md-12 mt-4">
                          <button className="text-white bookdemo_btn_inner w-100" type="submit">{submitloader ? <img src={require("../assets/whiteloader.gif")} alt='loader' /> : 'Schedule Your Free Trial'}</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      
      </div>
    </div>
  )
}

export default HomeMain
